import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/internal/Observable';
import { filter } from 'rxjs/internal/operators/filter';
import { Subject } from 'rxjs/internal/Subject';
import { AppEvent } from '../models/app-event';
import { AppEventType } from '../models/enum/app-event-type.enum';

@Injectable()
export class EventQueueService {
  private eventBroker = new Subject<AppEvent<any>>();

  on<T>(eventType: AppEventType): Observable<AppEvent<T>> {
    return this.eventBroker.pipe(filter((event) => event.type === eventType));
  }

  dispatch<T>(event: AppEvent<T>): void {
    this.eventBroker.next(event);
  }
}
